const bookEmojis = new Map([  
  ['Harry Potter', '🧙‍♂️🔮🦉'],
  ['Lord of the Rings', '🧝‍♂️🌋🪶'],
  ['Pride and Prejudice', '💕🎩🏰'],
  ['To Kill a Mockingbird', '🐦🕊️📖'],
  ['A Game of Thrones', '🐺🦁👑'],
  ['Hunger Games', '🏹🍞🔥'],
]);

export default bookEmojis;
